import { render, staticRenderFns } from "./DashboardInfoWidgets.vue?vue&type=template&id=731bb1c0&scoped=true"
import script from "./DashboardInfoWidgets.vue?vue&type=script&lang=js"
export * from "./DashboardInfoWidgets.vue?vue&type=script&lang=js"
import style0 from "./DashboardInfoWidgets.vue?vue&type=style&index=0&id=731bb1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731bb1c0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/DashboardInfoWidgets.vue
// module id = 8D9j
// module chunks = 41